import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobeFill = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.00711 9.00495L8.00211 10.9999L4.36035 8.26983C5.74203 5.44526 8.64399 3.5 12.0003 3.5C12.7115 3.5 13.4023 3.58735 14.0626 3.75192L13.0021 7.99995L9.00711 9.00495ZM16.0022 15L15.0022 17H12.0022L10.0022 14L11.1112 12.895L13.0542 13.019L16.0022 15Z",
		fill: "currentcolor"
	})]
});
export default SvgGlobeFill;
